import * as THREE from 'three';

export type WeaponType = 'cannon' | 'machinegun' | 'missile' | 'mine';

export interface WeaponConfig {
  name: string;
  type: WeaponType;
  damage: number;
  cooldown: number;
  ammo: number; // -1 for unlimited
  maxAmmo: number;
  projectileSpeed?: number;
  range?: number;
  areaOfEffect?: number; // AOE radius
}

export abstract class Weapon {
  public config: WeaponConfig;
  public currentAmmo: number;
  public canFire: boolean = true;
  protected cooldownTimer: number = 0;

  constructor(config: WeaponConfig) {
    this.config = config;
    this.currentAmmo = config.ammo;
  }

  update(deltaTime: number): void {
    if (!this.canFire) {
      this.cooldownTimer += deltaTime;
      if (this.cooldownTimer >= this.config.cooldown) {
        this.canFire = true;
        this.cooldownTimer = 0;
      }
    }
  }

  tryFire(): boolean {
    if (!this.canFire) return false;
    if (this.currentAmmo === 0) return false;

    this.canFire = false;
    if (this.currentAmmo > 0) {
      this.currentAmmo--;
    }

    return true;
  }

  reload(amount: number): void {
    if (this.config.ammo === -1) return; // Unlimited ammo
    this.currentAmmo = Math.min(this.currentAmmo + amount, this.config.maxAmmo);
  }

  abstract createProjectile(
    position: THREE.Vector3,
    direction: THREE.Vector3,
    owner: 'player' | 'enemy'
  ): any;

  getAmmoPercentage(): number {
    if (this.config.ammo === -1) return 1;
    return this.currentAmmo / this.config.maxAmmo;
  }
}
